import { Col, DateRangePickerField, ErrorMessage } from '@/components';
import { DEFAULT_ANALYSIS_START_YEAR } from '@/features/analysis/_utils';
import type { AnalysisSearchFormType } from '@/features/search/_models/analysis-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import dayjs from 'dayjs';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const FiscalYearRangeColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<AnalysisSearchFormType>();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <DateRangePickerField
        name="fiscalYearRange"
        label={t('created-fiscal-year')}
        control={control}
        errors={errors}
        picker="year"
        mode="year"
        allowEmpty={[true, true]}
        shouldCoexistOnChange
        disabledDate={(value) => {
          return value.isBefore(
            dayjs().year(DEFAULT_ANALYSIS_START_YEAR),
            'year',
          );
        }}
        required
        allowClear={false}
        wrapperStyle={{ marginBottom: 0 }}
        hiddenErrorMessage
        labelStyle={{ whiteSpace: 'nowrap' }}
      />
      <ErrorMessage errors={errors} name="fiscalYearRange" />
    </Col>
  );
});
